//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-sup",
  props:['sourceDto','defaultPar'],
  data(){
    return{
      selected:'base'
    }
  },
  methods:{
    viewSupList(sourceDto){
      this.$router.push(`/sources-sup-list/${sourceDto.id}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-sup.vue